import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    question: '¿Es un libro físico o digital?',
    answer: 'Todo el material del Método Coherencia Femenina es 100% digital. Recibirás acceso inmediato a los PDFs descargables que podrás leer en tu móvil, tablet u ordenador, o imprimirlos si lo prefieres.'
  }, {
    question: '¿Cuánto tiempo tengo acceso?',
    answer: '¡Para siempre! Una vez realices la compra, tendrás acceso de por vida a todo el material, incluyendo las futuras actualizaciones que se realicen a los manuales.'
  }, {
    question: '¿Necesito experiencia previa en desarrollo personal?',
    answer: 'No, en absoluto. El método está diseñado para llevarte paso a paso, desde los conceptos más básicos de regulación de energía hasta la implementación de hábitos avanzados, todo en un lenguaje claro y cercano.'
  }, {
    question: '¿Hay garantía de devolución?',
    answer: 'Sí, tienes una garantía de satisfacción de 7 días. Si sientes que el material no es para ti, te devolvemos el 100% de tu dinero sin hacer preguntas.'
  }, {
    question: '¿Cómo recibo el material?',
    answer: 'Inmediatamente después de tu compra, recibirás un correo electrónico con tus datos de acceso a la plataforma donde podrás descargar todos los manuales y bonos.'
  }, {
    question: '¿Puedo pagar con tarjeta o PayPal?',
    answer: 'Sí, aceptamos todas las tarjetas de crédito/débito principales y pagos a través de PayPal de forma 100% segura.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faq" className="py-24 bg-cream" data-id="element-123">
      <div className="max-w-3xl mx-auto px-6" data-id="element-124">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-125">
          <h2 className="text-3xl md:text-4xl font-serif text-burgundy mb-4" data-id="element-126">
            Preguntas Frecuentes
          </h2>
          <div className="w-24 h-1 bg-rosegold mx-auto rounded-full opacity-50" data-id="element-127"></div>
        </motion.div>

        <div className="space-y-4" data-id="element-128">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-white rounded-2xl overflow-hidden shadow-sm border border-cream" data-id="element-129">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-130">
                <span className="font-medium text-burgundy text-lg" data-id="element-131">
                  {faq.question}
                </span>
                <ChevronDown className={`text-rosegold transition-transform duration-300 flex-shrink-0 ml-4 ${openIndex === index ? 'rotate-180' : ''}`} size={20} data-id="element-132" />
              </button>
              <AnimatePresence data-id="element-133">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-134">
                    <div className="px-6 pb-5 text-taupe leading-relaxed" data-id="element-135">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}